module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/flash-black-phone.82007c79.mp4";